/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionOpenUserProfile';

const ActionOpenUserProfileManager: ActionManagerFn<'ActionOpenUserProfile'> = (
  platform: Platform,
): ActionManager<'ActionOpenUserProfile'> => {
  return {
    ...baseActionManager(platform, 'ActionOpenUserProfile'),
    defaultValue,
    props: {
      ...baseActionProps,
    },
    name: 'Open User Profile',
    icon: { iconName: 'user' },
    description: `**Overview**<br/>
The Open User Profile action is a system-level navigation component designed to display the account settings interface for the currently logged-in user. It triggers a standard, platform-provided popup or modal where users can view and modify their personal details, such as their password, email address, avatar, or preferences.<br/><br/>
This component functions as a pre-configured shortcut to the user management profile. It operates without any specific configuration parameters, ensuring a consistent profile management experience across the entire application without requiring developers to build custom forms for standard account tasks.

**Key Features**<br/>
* **System Integration:** Directly hooks into the platform's authentication and user management system to display the correct data for the active session.
* **Zero Configuration:** Inherits all properties directly from baseActionManager and baseActionProps, requiring no inputs or target IDs from the developer to function.

**Properties**<br/>
* **Base Properties:** This component utilizes ...baseActionProps exclusively, accepting only the standard configuration options available to all actions.

**Use Cases**<br/>
* **Header Navigation:** Attached to a "My Profile" button or the user's avatar icon in the application's top navigation bar.
* **Account Management:** Placed in a "Settings" menu to allow users to quickly update their password or contact information.`,
  };
};

export default ActionOpenUserProfileManager;
